export function convertDate(date: string | number | Date) {
  const newDate = new Date(date);
  return (
    newDate.getDate() +
    "/" +
    (newDate.getMonth() + 1) +
    "/" +
    newDate.getFullYear()
  );
}

export function convertDateTime({ date }: { date: string | number | Date }) {
  const newDate = new Date(date);
  return new Date(newDate).toLocaleString("en-au", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function toIsoStringDateTime(date: string | number | Date) {
  const newDate = new Date(date);
  var pad = function (num: number) {
    return (num < 10 ? "0" : "") + num;
  };

  return (
    newDate.getFullYear() +
    "-" +
    pad(newDate.getMonth() + 1) +
    "-" +
    pad(newDate.getDate()) +
    "T" +
    pad(newDate.getHours()) +
    ":" +
    pad(newDate.getMinutes()) +
    ":" +
    pad(newDate.getSeconds())
  );
}

export function toIsoStringDate(date: string | number | Date) {
  const newDate = new Date(date);
  var pad = function (num: number) {
    return (num < 10 ? "0" : "") + num;
  };

  return (
    newDate.getFullYear() +
    "-" +
    pad(newDate.getMonth() + 1) +
    "-" +
    pad(newDate.getDate())
  );
}

export function formatDate(dateTimeString: string) {
  const date = new Date(dateTimeString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
